import {
  OPEN_MENU,
  OPEN_POPUP,
  OPEN_POPUP_BG,
  SET_INFO_MODAL,
  BODY_SCROLL
} from '../constants'

const initialState = {
  backdropOpen: false,
  menuOpen: false,
  modalOpen: false,
  backdropHighZindex: false,
  infoPopup: false,
  bodyScroll: true
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_MENU:
      return {
        ...state,
        menuOpen: action.state,
        backdropOpen: action.state
      }
    case OPEN_POPUP:
      return {
        ...state,
        modalOpen: action.state,
        backdropOpen: action.state
      }
    case OPEN_POPUP_BG:
      return {
        ...state,
        backdropOpen: action.state,
        backdropHighZindex: action.state
      }
    case SET_INFO_MODAL:
      return {
        ...state,
        infoPopup: action.content
      }
    case BODY_SCROLL:
      return {
        ...state,
        bodyScroll: action.bodyScroll
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/backdrop.js